 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		54: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		54: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"1":"Assessments~AssignmentsModalV2~AssignmentsV2~DirectShareWorksheets~KidFrameDetail~MyAssignments~MySt~912a9358","2":"AssignmentsV2~GradeFilteredContentCards~HomeLearning~InteractiveWorksheetsOverview~MyAssignments~MyC~3abcad88","3":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","6":"vendors~Assessments~GoalDetails~MemberHomepage~ProgressTracker","7":"Checkout~Gift~UpdatePayment","8":"LandingPage~Pricing","9":"RegistrationModal","11":"AccountSettings","12":"Assessments","13":"AssignmentsModalV2","14":"AssignmentsV2","15":"BrainzyPaint","16":"Checkout","17":"DirectShareWorksheets","18":"FeaturedArtwork","19":"FillableWorksheet","20":"Gift","21":"GoalDetails","22":"GradeFilteredContentCards","23":"GradeWorksheetModal","24":"HomeLearning","25":"InteractiveWorksheetsOverview","26":"KidFrame","27":"KidFrameDetail","28":"LandingPage","29":"MemberHomepage","30":"MyAssignments","31":"MyCollections","32":"MyStudents","33":"Onboarding","34":"PracticeSkill","35":"PredefinedCollectionsDetail","36":"Pricing","37":"ProgressTracker","38":"RelatedGuidedLesson","39":"Reviews","40":"SeasonalDaysDropdown","41":"Sellpage","42":"SubPlansList","43":"SubmissionsReportPage","44":"SwitchAccountModal","45":"TakeAssessmentModal","46":"TopNav","47":"UpdatePayment","48":"UserMenu","49":"vendors~Gift","50":"vendors~MemberHomepage","51":"vendors~MyStudents","52":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"1ff8f1f48b7749858cba","1":"72f8a99dbdfe8a5da92d","2":"9a01a8c7b0aedd789e9e","3":"c0e414ba62e1fabb408b","4":"49ec81c4b000f3faed41","5":"760b727dcfc2922613cf","6":"78f579684b8997ba2593","7":"57d017d0c18ea150704c","8":"1339b9bebfb09fb65114","9":"ab775ae375b567f1c0df","10":"d67774f96075943aecc1","11":"83c59463799a13a7cf4f","12":"0d3c856d740346d8aba0","13":"9ac7fd211801c896e35d","14":"06d61217b774e95302e8","15":"4b700cf7173846756a4e","16":"a24709de80c1d80c39e2","17":"4d0e3ffe8146d0127234","18":"2f5dad07badbc0353bd6","19":"55f37258e8e2c6268ce6","20":"f7b426d7f17212220d34","21":"8b346a221e29b9b9664b","22":"be52f895493a7ccb0410","23":"8adccadc6e15ab1b23b6","24":"c8d09f991a48c88cda19","25":"50bd9ec84eb5a6be2bd4","26":"d1dccf9dcbb823639242","27":"7fe9ea04ddafd1b44543","28":"82e86e74176d8c3cb2fd","29":"3dc61b671f161d27c75c","30":"d30440406433a0423592","31":"3ce7d5acb90c586f529d","32":"fb970df051afc683122b","33":"3584c3099373c8225ad4","34":"c9b5b8865b5b9ded6752","35":"4eacc873ec18d6eaa562","36":"d1f810e03b4e82fc2d9f","37":"3dc928fde872b3663e9b","38":"f79af52800eeab40001b","39":"6be5d1aee406ac188366","40":"8091a5099f9f466b1738","41":"cc7e58aeae8d402a585d","42":"afdf37c89fc310ea8a7c","43":"84e7b809d50fb4a3d58e","44":"f8f3b9066e01b937ccbd","45":"806bfbd2544c9894be10","46":"ecc1cb17f9306f1c9ffe","47":"aa0430044d4a0a8352c5","48":"807c3d3088df3b7a4238","49":"1ad527a6889892075af5","50":"43073a1c3fdae16a2d97","51":"ba38e6d6b1b7ac6cb8f5","52":"5e364b3a3ed04303c0f3","53":"cb58365346d77cd81571","56":"1ea6a865c939a75b931d","57":"3b2b7e8d67d9321f113e","58":"cce2caa1dc522986e8c4","59":"2482a317f898d0988fa0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"7":1,"8":1,"9":1,"11":1,"12":1,"13":1,"14":1,"16":1,"17":1,"18":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"36":1,"37":1,"39":1,"40":1,"41":1,"43":1,"45":1,"46":1,"47":1,"48":1,"49":1,"56":1,"57":1,"58":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"1":"Assessments~AssignmentsModalV2~AssignmentsV2~DirectShareWorksheets~KidFrameDetail~MyAssignments~MySt~912a9358","2":"AssignmentsV2~GradeFilteredContentCards~HomeLearning~InteractiveWorksheetsOverview~MyAssignments~MyC~3abcad88","3":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","6":"vendors~Assessments~GoalDetails~MemberHomepage~ProgressTracker","7":"Checkout~Gift~UpdatePayment","8":"LandingPage~Pricing","9":"RegistrationModal","11":"AccountSettings","12":"Assessments","13":"AssignmentsModalV2","14":"AssignmentsV2","15":"BrainzyPaint","16":"Checkout","17":"DirectShareWorksheets","18":"FeaturedArtwork","19":"FillableWorksheet","20":"Gift","21":"GoalDetails","22":"GradeFilteredContentCards","23":"GradeWorksheetModal","24":"HomeLearning","25":"InteractiveWorksheetsOverview","26":"KidFrame","27":"KidFrameDetail","28":"LandingPage","29":"MemberHomepage","30":"MyAssignments","31":"MyCollections","32":"MyStudents","33":"Onboarding","34":"PracticeSkill","35":"PredefinedCollectionsDetail","36":"Pricing","37":"ProgressTracker","38":"RelatedGuidedLesson","39":"Reviews","40":"SeasonalDaysDropdown","41":"Sellpage","42":"SubPlansList","43":"SubmissionsReportPage","44":"SwitchAccountModal","45":"TakeAssessmentModal","46":"TopNav","47":"UpdatePayment","48":"UserMenu","49":"vendors~Gift","50":"vendors~MemberHomepage","51":"vendors~MyStudents","52":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"37f3561d020909d6f9dc","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"45d4d2727ad4cf9e9a52","8":"2b436e69b3b155a4a770","9":"0c746aaf69e72daa6653","10":"31d6cfe0d16ae931b73c","11":"4ad35bb3dca41c2cae0b","12":"86cacad3a6a486e41391","13":"13a4e7436120b3088257","14":"790c8fc25b5afd20eafb","15":"31d6cfe0d16ae931b73c","16":"96a6752e29d47e240e93","17":"96f10993de42e552b4f0","18":"d56d9288e4c0c7368f48","19":"31d6cfe0d16ae931b73c","20":"7975b8102de7d4dd0e46","21":"70874abc2be77d282a23","22":"cc59a2d5075b55748ffc","23":"78f108ef2a1e16d4d1b4","24":"4c89bea8f7f35505c32a","25":"8d1356e1827dc4463b48","26":"efb1490518191223d63d","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"908acb1c52d88ce74b41","30":"011197c4e4217815b0b8","31":"7437bb58b99b603d32fc","32":"1f64f945f7b833aae61b","33":"f3c4d7315b2cad9c81cd","34":"5491656ee574e8b4a49d","35":"31d6cfe0d16ae931b73c","36":"3a33133d8b4cb1687191","37":"85451f8c42dae0de4f7f","38":"31d6cfe0d16ae931b73c","39":"ba9c0fc38afc58c1902d","40":"495c0b9853cb793a31ee","41":"fed495f6ff9f57243990","42":"31d6cfe0d16ae931b73c","43":"05cfc41a18b80aeac5d7","44":"31d6cfe0d16ae931b73c","45":"bf40f2159a5c06b0446f","46":"ddb24ea7ffcfea2391aa","47":"cb30306a496b38be9101","48":"f73ff81cf842ea909b56","49":"ca68f8fa1dd9edae64fc","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","56":"d7fbd1904b7d8ac3ae36","57":"c7c112df630d782cdeed","58":"c7c112df630d782cdeed","59":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([401,55]);
 	// run deferred modules when ready
 	return checkDeferredModules();
